import React from 'react'
import {useDispatch} from 'react-redux'
import styled from '@emotion/styled'
import {WidgetLabelTypes} from 'utils/label'

import {Button} from '@daedalus/atlas/Button'
import {Grid} from '@daedalus/atlas/helpers/Grid'
import {Icon} from '@daedalus/atlas/Icon'
import {SkeletonLoader} from '@daedalus/atlas/SkeletonLoader'
import {trackEvent} from '@daedalus/core/src/analytics/modules/actions'
import {
  Action,
  Category,
  Entity
} from '@daedalus/core/src/analytics/types/Events'
import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage'

interface FooterProps {
  partnerKey: string
  isDataLoaded?: boolean
  isSoldOut?: boolean
  label?: string
  hotelsNumber?: number
  redirectUrl?: string
  isShowFallbackText?: boolean
}
const BottomContentContainer = styled(Grid)`
  width: 100%;
  flex-basis: 48px;
`

const ButtonWrapper = styled('div')`
  max-width: 384px;
  width: 100%;
`
const StyledIcon = styled(Icon)`
  & svg {
    /* @mirror */
  }
`

export const ButtonSkeleton = () => <SkeletonLoader height={48} />

export const SeeMoreButton = ({
  hotelsNumber,
  redirectUrl,
  isShowFallbackText,
  partnerKey,
  label,
  isSoldOut,
  isDataLoaded
}: FooterProps) => {
  const dispatch = useDispatch()

  if (isDataLoaded && isSoldOut) return null

  const onClick = (event: React.SyntheticEvent) => {
    event.stopPropagation()

    dispatch(
      trackEvent({
        category: Category.User,
        entity: Entity.SeeAllStays,
        action: Action.Clicked,
        payload: {
          partnerKey,
          widgetType: WidgetLabelTypes.multipleHotelsWithSearch,
          label
        }
      })
    )

    if (redirectUrl) {
      window.open(redirectUrl, '_blank')
    }
  }

  return (
    <BottomContentContainer
      container
      alignItems="center"
      justify="center"
      spacing="s000"
    >
      <ButtonWrapper>
        {isDataLoaded ? (
          <Button
            fullWidth
            variant="secondary"
            onClick={onClick}
            iconEnd={<StyledIcon size="sm" name="Share" />}
            data-dd-action-name="SeeMoreProperties"
            size="lg"
          >
            {hotelsNumber && !isShowFallbackText ? (
              <FormattedMessageWrapper
                id="multipleHotelsWidget.seeAllDealsButton"
                defaultMessage="See all {hotelsNumber} deals"
                values={{
                  hotelsNumber
                }}
              />
            ) : (
              <FormattedMessageWrapper
                id="multipleHotelsWidgetWithSearch.seeMoreStaysButton"
                defaultMessage="See more stays"
              />
            )}
          </Button>
        ) : (
          <ButtonSkeleton />
        )}
      </ButtonWrapper>
    </BottomContentContainer>
  )
}
